/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2ActiveBoardsIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2ActiveBoardsIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2ActiveBoardsIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2ActiveBoardsIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 14"
 style={{'--as-1-1exHGF': alignSelf,'--mt-2-1exHGF': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1exHGF': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1exHGF': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1exHGF': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1exHGF': opacity,'--w-10-1exHGF': typeof width === 'number' ? `${width}px` : width,'--h-11-1exHGF': typeof height === 'number' ? `${height}px` : height,'--f-12-1exHGF': fill,'--a-7-1exHGF': isAnimated ? animation : "none",'--sd-8-1exHGF': isAnimated ? strokeDashoffset : 0,'--sd-9-1exHGF': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2ActiveBoardsIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M4.25 0a1 1 0 00-1 1v.5a1 1 0 001 1h3a1 1 0 001-1V1a1 1 0 00-1-1h-3zM1.5 1H2v.5a2.25 2.25 0 002.25 2.25h3A2.25 2.25 0 009.5 1.5V1h.5a1.5 1.5 0 011.5 1.5v10A1.5 1.5 0 0110 14H1.5A1.5 1.5 0 010 12.5v-10A1.5 1.5 0 011.5 1z"
 style={{'--f-12-1exHGF': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}